<template>
    <div class="designer__contain">
        <NavSecond :banner="icon_stra"></NavSecond>
        <div class="wrapper__w">
            <el-row :gutter="0" class="designer__base--box">
                <el-col :span="16" class="designer__base--boxleft relative">
                    <div class="designer_type">
                        <span>{{baseInfo.name}}<div class="line"></div></span>
                    </div>
                    <div class="designer_des" v-html="baseInfo.sign"></div>
                    <el-divider class="lin"></el-divider>
                </el-col>
                <el-col :span="8" class="designer__base--boxrigth">
                    <div class="designer_head"><img :src="baseInfo.image"></div>
                </el-col>
            </el-row>
            <div style="padding-top: 50px" v-html="baseInfo.content"></div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Footer from '@/layouts/Footer'
    import icon_stra from '@/assets/img/strabanner.png'
    import NavSecond from '@/components/NavSecond'
    export default {
        name: 'Test',
        data (){
            return {
                icon_stra,
                baseInfo:{}
            }
        },
        components: {
            NavSecond,
            Footer
        },
        methods: {
            /**
             * @description详情
             * */
            getDetail (){
                this.$xhr(this.$api.designerdDetail, {id: this.$route.query.id}).then(res => {
                    this.baseInfo = res
                })
            },
        },
        mounted() {
            this.getDetail()
        }
    }
</script>
<style  lang="scss" scoped>
   .designer__contain{
       .designer__base--box{
           height: 360px;
           margin-top: 100px;
           .designer_type{
               font-size: 35px;
               font-weight: bold;
               color: #010101;
               padding: 100px 0;
               span{
                   position: relative;
               }
               .line{
                   position: absolute;
                   left: 0;
                   bottom: -20px;
                   width: 32px;
                   height: 4px;
                   background: #F55E1B;
               }

           }
           .designer_des{
               font-size: 18px;
               font-weight: 400;
               color: #000000;
               line-height: 32px;
           }
           .designer_head{
               text-align: right;
               img{
                   object-fit: cover;
                   width: 318px;
                   height: 360px;
               }
           }
           .lin{
               position: absolute;
               bottom: 0;
               left: 0;
               margin: 0;
               background-color: #F15315;
           }
           .designer__base--boxleft{
               height: 360px;
           }
       }

   }
</style>
